module.exports = __webpack_public_path__ + "assets/images/openClosedOfficePlan-01.87b51677002083c21166ef3fe19d5b95.svg";